import { useParams, useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import axios from "axios";
import "./Form.scss"

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [cpassword, setCPassword] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = "hidden";
    document.body.classList.add("login-open");

    return () => {
      document.body.style.overflow = "auto";
      document.body.classList.remove("login-open");
    };
  }, []);

  const handleSubmit = async (e) => {
    if (!password) return alert("Please enter your new password.");
    if (!cpassword) return alert("Please confirm your new password.");
    if (password !== cpassword) return alert("Passwords do not match.");
    if (password.length < 8) return alert("Password must be at least 8 characters long.");

    e.preventDefault();
    try {
      const res = await axios.post(`/reset-password/${token}`, { password });
      setMessage(res.data.message);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setMessage(err.response?.data?.error || "Something went wrong");
    }
  };

  return (
    <>
    <div className="overlay"></div>
    <div className="form-container">
      <h2>Reset Your Password</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
        <input
          type="password"
          placeholder="Enter new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        </div>
        <div className="form-group">
        <input
          type="password"
          placeholder="Confirm new password"
          value={cpassword}
          onChange={(e) => setCPassword(e.target.value)}
          required
        />
        </div> 
        <button type="submit">Reset Password</button>
      </form>
      <p>{message}</p>
    </div>
    </>
  );
};

export default ResetPassword;
